import { api } from "../Api";
import i18n from "../../Config/i18n.js";

/**
 * Classe que faz as requisições dos equipamentos
 */
export class EquipamentoRequest {
    /**
     * Faz a requisição dos dados para os cards
     * @returns {Object} Lista de equipamentos   data = 2024-01-30
     */
    async CardsRequest(id: string, data:string):Promise<any>{
        try {
            const response = await api.get(`/dashboard/${id}?date=${data}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição dos dados para os cards
     * @returns {Object} Lista de equipamentos   data = 2024-01-30
     */
    async allCardsRequest(data:string):Promise<any>{
        try {
            const response = await api.get(`/dashboardGeral?date=${data}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição dos dados para o infográfico do dia
     * @returns {Object} Lista de equipamentos   data = 2024-01-30
     */
    async daysRequest(id: string, data:string, card:string, flag:number, key: string, idEquipment: string):Promise<any>{
        try {
            let response = {
                data: []
            }
            if(key && idEquipment){
                response = await api.get(`/dashboardMonth/${id}?date=${data}&card=${card}&flag=${flag}&key=${key}&idEquipment=${idEquipment}`);
            }else if(idEquipment){
                response = await api.get(`/dashboardMonth/${id}?date=${data}&card=${card}&flag=${flag}&idEquipment=${idEquipment}`);
            }else if(key){
                response = await api.get(`/dashboardMonth/${id}?date=${data}&card=${card}&flag=${flag}&key=${key}`);
            }else{
                response = await api.get(`/dashboardMonth/${id}?date=${data}&card=${card}&flag=${flag}`);
            }
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição dos dados para o infográfico do dia
     * @returns {Object} Lista de equipamentos   data = 2024-01-30
     */
    async allDaysRequest(data:string, card:string, flag:number):Promise<any>{
        try {
            const response = await api.get(`/dashboardMonthGeral?date=${data}&card=${card}&flag=${flag}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição dos dados para o infográfico do dia
     * @returns {Object} Lista de equipamentos   data = 2024-01-30
     */
    async getStatusGeral(data:string):Promise<any>{
        try {
            const response = await api.get(`/dashboardStatusGeral?date=${data}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    // Pega os equipamentos que o usuário tem acesso
    async getEquipamentosByUser(): Promise<any>{
        try {
            const Equipamentos = await api.get(`/me/authorizedPocosAndReservatoriosAndGrouppingsSeparated`);
            return Equipamentos.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                if(error.response?.data?.message){throw new Error(error.response.data.message)}
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    // Pega os dados em formato excel do equipamento
    async getExcel(id: string, datainicio: string, datafim: string, analysisMode: boolean, readingMode: boolean, methodOld: boolean, extension?: string): Promise<any>{
        const requestBody: any = {
            equipment: id,
            datainicio,
            datafim,
            analysisMode,
            methodOld,
        };

        if (methodOld === false) {
            requestBody.format = extension;
            requestBody.protected = readingMode;
        }
        
        try {
            const response = await api.post(`equipments/export/mappings/excel`, requestBody, {responseType: 'blob', timeout: 300000});
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if(error.response?.status === 403){
                const text = await error.response.data.text();
                const json = JSON.parse(text);
                throw new Error(json.message);
            } else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    // Pega os dados em formato excel do equipamento
    async getReport(id: string, datainicio: string, datafim: string): Promise<any>{
        try {
            const response = await api.get(`sendReport/${datainicio}/${datafim}/${id}`);
            return response;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    async RequestCities():Promise<any>{
        try {
            const response = await api.get('/me/authorizedCities');
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }
}
export const equipamentoRequest = new EquipamentoRequest();


/**
 * Classe que faz as requisições dos equipamentos
 */
export interface DonutItem {
  id: number;
  name: string;
  key: string;
  itens: {
    label: string;
    value: number;
  }[];
  total: number;
  unit: string;
}

export interface Card {
  id: number;
  name: string;
  key: string;
  production: number;
  unit: string;
  Active: boolean;
  type: number;
}

interface BalanceItemGroup {
  itens: Record<string, number>;
  total: number;
  unit: string;
}

interface CardApiItem {
  production: number;
  unit: string;
}

interface LossControlResponse {
  balance: Record<string, BalanceItemGroup>;
  cards: Record<string, CardApiItem>;
}

export class ControlePerdasRequest {

  /**
   * Método privado único que faz a requisição
   */
  private async fetchLossControl(data: string): Promise<LossControlResponse> {
    try {
      const response = await api.get(`/lossControl/${data}`);
      return response.data;
    } catch (error: any) {
      if (error.response?.status === 401) {
        throw Object.assign(
          new Error(i18n.t("request-errors.unauthenticated")),
          { status: 401 }
        );
      }

      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }

      throw new Error(i18n.t("request-errors.server-connection"));
    }
  }

  /**
   * Faz 1 request e retorna tudo já tratado
   */
  async getDashboardData(data: string): Promise<{
    donut: DonutItem[];
    cards: Card[];
  }> {

    const response = await this.fetchLossControl(data);

    // Normalização Donut
    const donut: DonutItem[] = Object.entries(response.balance).map(
      ([name, values], index) => ({
        id: index,
        name,
        key: name,
        itens: Object.entries(values.itens || {}).map(
          ([label, value]) => ({
            label,
            value
          })
        ),
        total: values.total,
        unit: values.unit
      })
    );

    // Normalização Cards
   const cards: Card[] = Object.entries(response.cards).map(
    ([name, values], index) => {
        const balanceKey = name.split(":")[0]; // pega o índice interno de balance
        return {
        id: index,
        name,                 // mantém o nome original
        key: balanceKey,      // key = índice interno
        production: values.production,
        unit: values.unit,
        Active: true,
        type: 0
        };
    }
    );

    console.log('RESPONSE CONTROLE PERDAS', cards);
    
    return { donut, cards };
  }

  async Chart( eta: string, data: string, flag: number): Promise<any> {
        console.log("chart", eta)
        try {
            const url = `/lossControl/${eta}?date=${data}&flag=${flag}`;

            const response = await api.get(url);
            
            // console.log('RESPONSE CHART', response.data)

            return response.data;

        } catch (error: any) {
            if (error.response?.status === 401) {
                throw Object.assign(
                    new Error(i18n.t('request-errors.unauthenticated')),
                    { status: 401 }
                );
            } else if (error.response?.data?.message) {
                throw new Error(error.response.data.message);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }
}

export const controlePerdasRequest = new ControlePerdasRequest();